import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import app from './app';
import login from './login';
import profile from './profile';
import academy from './academy';
import candidates from './candidates';
import reports from './reports';
import sessions from './sessions';
import company from './company';
import entity from './entity';
import ats from './ats';

export * from './app';
export * from './login';
export * from './profile';
export * from './academy';
export * from './candidates';
export * from './reports';
export * from './sessions';
export * from './company';
export * from './entity';
export * from './ats';

const appReducer = combineReducers({
	app,
	login,
  profile,
  academy,
  candidates,
  reports,
  sessions,
  company,
  entity,
  ats,
  routing: routerReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js